import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import Loader from "components/Loader";
import Modal from "components/Modal";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import React from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import theme from "theme";
import {
    ethnicityOptions,
    eyeColorOptions,
    hairColorOptions,
    tattoosOptions,
} from "./constants";
import { usePhysicalDetails } from "./usePhysicalDetails";

export const PhysicalDetails: React.FC = React.memo(() => {
    const {
        inputs,
        handleInputChange,
        handleSelectChange,
        clickedOnNext,
        onSubmit,
        isLoading,
        handleBack,
        isFetching,
        isSubmitDisabled,
        handleSaveAndNext,
        isModalOpen,
        toggleModal,
    } = usePhysicalDetails();

    return (
        <PageContent>
            <ProfileContentWrapper>
                {isFetching && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (3/7)
                </Text>
                <SubHeading variant="label">
                    PHYSICAL DETAILS <StraightLine />
                </SubHeading>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="weight"
                        type="number"
                        label="Weight(kg)"
                        required
                        placeholder="Enter Weight"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.weight}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                    <TextInput
                        min={120}
                        max={210}
                        name="height"
                        type="number"
                        label="Height(cm)"
                        required
                        placeholder="Enter Height"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.height}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        min={65}
                        max={150}
                        name="hips"
                        type="number"
                        label="Hips(cm)"
                        required
                        placeholder="Enter Hips"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.hips}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                    <TextInput
                        min={50}
                        max={110}
                        name="waist"
                        type="number"
                        label="Waist(cm)"
                        required
                        placeholder="Enter Waist"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.waist}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                    <TextInput
                        min={65}
                        max={150}
                        name="bust"
                        type="number"
                        label="Bust/Chest(cm)"
                        required
                        placeholder="Enter Bust"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.bust}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <SingleSelect
                        name="eye_color"
                        type="text"
                        label="Eye Color"
                        required
                        placeholder="Enter Eye Color"
                        searchable
                        color={theme.colors.text}
                        minWidth="160px"
                        value={inputs.eye_color}
                        options={eyeColorOptions}
                        onChange={(value) =>
                            handleSelectChange("eye_color", value)
                        }
                        disabled={isLoading}
                    />
                    <SingleSelect
                        name="hair_color"
                        type="text"
                        label="Hair Color"
                        required
                        searchable
                        placeholder="Enter Hair Color"
                        options={hairColorOptions}
                        color={theme.colors.text}
                        minWidth="160px"
                        value={inputs.hair_color}
                        onChange={(value) =>
                            handleSelectChange("hair_color", value)
                        }
                        disabled={isLoading}
                    />
                    <TextInput
                        name="hair_length"
                        type="number"
                        label="Hair Length(cm)"
                        required
                        placeholder="Enter Hair Length"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.hair_length}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <SingleSelect
                        name="piercings"
                        type="text"
                        label="Piercings"
                        required
                        placeholder="Enter Piercings"
                        color={theme.colors.text}
                        minWidth="160px"
                        value={inputs.piercings}
                        options={tattoosOptions}
                        onChange={(value) =>
                            handleSelectChange("piercings", value)
                        }
                        disabled={isLoading}
                    />
                    {/* <TextInput
                        name="genres"
                        type="text"
                        label="Genres"
                        required
                        placeholder="Enter Genres"
                        labelColor={theme.colors.text}
                        minWidth="160px"
                        value={inputs.genres}
                        onChange={handleInputChange}
                        disabled={isLoading}
                    /> */}
                    <SingleSelect
                        name="ethnicity"
                        type="text"
                        label="Ethnicity"
                        required
                        placeholder="Enter Ethnicity"
                        searchable
                        color={theme.colors.text}
                        minWidth="160px"
                        value={inputs.ethnicity}
                        options={ethnicityOptions}
                        onChange={(value) =>
                            handleSelectChange("ethnicity", value)
                        }
                        disabled={isLoading}
                    />
                    <SingleSelect
                        name="tattoos"
                        type="text"
                        label="Tattoos"
                        required
                        placeholder="Enter Tattoos"
                        color={theme.colors.text}
                        minWidth="160px"
                        value={inputs.tattoos}
                        options={tattoosOptions}
                        onChange={(value) =>
                            handleSelectChange("tattoos", value)
                        }
                        disabled={isLoading}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        icon={<BsArrowLeft />}
                        iconPosition="prefix"
                        onClick={toggleModal}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        onClick={onSubmit}
                        isLoading={!clickedOnNext && isLoading}
                        disabled={isSubmitDisabled}
                    >
                        Save
                    </Button>
                    <Button
                        type="button"
                        variant="filled"
                        icon={<BsArrowRight />}
                        iconPosition="suffix"
                        isLoading={clickedOnNext && isLoading}
                        onClick={handleSaveAndNext}
                        disabled={isSubmitDisabled}
                    >
                        Save and Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Confirm</Text>
                </Modal.Header>
                <Modal.Content>
                    <Text variant="body1">
                        Are you sure you want to leave? Any unsaved changes will
                        be lost.
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        expanded
                        marginTop={2}
                        columnGap={1}
                        rowGap={1}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={toggleModal}
                        >
                            No
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            onClick={handleBack}
                        >
                            Yes
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </PageContent>
    );
});

PhysicalDetails.displayName = "PhysicalDetails";
